import { useState, useEffect } from 'react'

export type Platform = 'pc' | 'app'

const MOBILE_BREAKPOINT = 768

export function usePlatform(): Platform {
  const [platform, setPlatform] = useState<Platform>(() => {
    if (typeof window === 'undefined') return 'pc'
    return window.innerWidth < MOBILE_BREAKPOINT ? 'app' : 'pc'
  })

  useEffect(() => {
    const handleResize = () => {
      setPlatform(window.innerWidth < MOBILE_BREAKPOINT ? 'app' : 'pc')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return platform
}

export function useIsMobile(): boolean {
  return usePlatform() === 'app'
}

export function useIsDesktop(): boolean {
  return usePlatform() === 'pc'
}

export function useResponsive<T>(pcValue: T, appValue: T): T {
  const platform = usePlatform()
  return platform === 'pc' ? pcValue : appValue
}
